import {Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const SUGMDT1 = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'><ol><li><b>Open</b> the downloaded <b>PDB file</b></li><li>Click on the Select option of the toolbar, and choose any part of the molecule you would like to remove (e.g. ions, ligand, solvent, a specific protein chain in the file, etc.). Note that if you only want one specific chain out of multiple, you could save some time by selecting the chain you want to study, instead, and then click on <b><i>Select → Invert selection</i></b>, to select every other part in the structure.</li><li>Go to <b><i>Actions → Atoms/Bonds → delete.</i></b></li><li><b>Repeat steps 2 and 3</b>, until you only have the desired molecular structure.</li><li>Save the file.</li></ol></Text>
        </Content>
      </Layout>
    </Layout>
  );
};

export default SUGMDT1;
